"use client"

import { FileExclamationPoint } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `FileExclamationPointIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const FileExclamationPointIcon = component(Icon)({
  as: FileExclamationPoint,
})
